<template>
  <div class="mt-1 py-1 px-3" style="background-color: #ebf3ff;">
    <v-progress-linear indeterminate v-if="loading" />

    <div class="card text-left">
      <div class="card-header pt-2 purple--text text-center"> SUBE LOS DOCUMENTOS DE INSCRIPCION </div>
      <v-divider class="grey my-2" />
      <div class="card-body">
        
        <template vv-if="!view_format_table" >
          <div class="row text-left" v-for="(d,ind) in documentaciones" :key="ind">
            <div class="mt-3 col-xs-12">
              <label class="form-label mb-0"> <b> {{d.tipoDocumentoPersona.nombre}} </b> </label>
              <input type="file" accept=".pdf,.png,.jpg,.jpeg" v-on:change="setterFile($event,d.tipoDocumentoPersona)" class="form-control form-control-sm" >
            </div> 
            
            <div class="mb-3 col-xs-12" v-for="(p,ind2) in d.tipoDocumentoPersona.plantillaDatos" :key="ind2" >
              <span> {{p.etiqueta}} </span>
              <input :type="p.tipo" v-model="p.valor" class="form-control form-control-sm" >

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="green" v-if="d.cargado" small outlined @click="visualizarDocumento(d.cargado.documentoPersona)" v-bind="attrs" v-on="on" >
                    <v-icon>mdi-eye</v-icon>
                  </v-btn>
                </template>
                <span>Visualizar el documento</span>
              </v-tooltip>

              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn class="ml-2" v-if="d.cargado" color="orange" small outlined @click="actualizarDocumento(d,p)" v-bind="attrs" v-on="on" >
                    <v-icon>mdi-content-save</v-icon>
                  </v-btn>
                </template>
                <span>Actualizar documento</span>
              </v-tooltip>

            </div> 
  
            <div class="col-xs-12">
              <v-divider class="blue lighten-3 mt-1" />
            </div>
          </div> 
        </template>

        <div v-if="view_format_table"> 
        </div>
      </div>
    </div> 

    <Visualizar ref="refVisualizar"/>
  </div>
</template>

<script>
import {getRequisitos,getCargados} from './documents/docs'
import Visualizar from './documents/documento-view.vue'
import { actualizarDatos } from './documents/docs-up'

  export default {
    components:{Visualizar},
    data () {
      return {
        loading: false, 
        documentaciones: [],
        cargados: [],
        id_ins: null, 
        view_format_table: false,
      }
    },
    methods:{
      setterFile(e,p){
        p.archivo = e.target.files[0]; 
      },
      setViewAsTable(si){
        this.view_format_table = si;
      },

      async cargarRequisitosDocs(institucionId,categoriaId,verificar_idins=null){
        this.id_ins = verificar_idins;
        this.loading = true;
        this.documentaciones = [];
        this.cargados = [];
        let baseurl = process.env.VUE_APP_URL_DOCUMENTOS+'/requisitos-documentales';
        window.console.log('vueee', process.env);
        let res = await getRequisitos(baseurl,institucionId,categoriaId);
        if(verificar_idins){
          await this.verificarCargados(verificar_idins,res);
        }
        this.loading = false;
        this.documentaciones = res;
        window.console.log('res',res);
      },

      async verificarCargados(ins_id,pacargar){
        let baseurl = process.env.VUE_APP_URL_DOCUMENTOS+'/inscripciones-documentos-personas/inscripciones/'+ins_id;
        let datos = await getCargados(baseurl);
        window.console.log('cargados:::', datos);
        datos.forEach(x=>{
          let existe = pacargar.find(p=>p.tipoDocumentoPersonaId == x.documentoPersona.tipoDocumentoPersonaId);
          if(existe){
            existe.cargado = x;
          }
        })
        this.cargados = datos;
      },

      getRequisitos(opcionales=false) {
        let txt_archivos = '';
        if(this.documentaciones){
          this.documentaciones.forEach(d=>{
            if(!d.tipoDocumentoPersona.archivo){
              txt_archivos += ' Seleccione el archivo para: '+d.tipoDocumentoPersona.nombre;
            }
            d.tipoDocumentoPersona.plantillaDatos.forEach((p) => {  
              if(!p.valor && p.archivo){
                txt_archivos += ' Ingrese un valor para: '+p.etiqueta
              }
              if(!p.valor && !p.archivo){
                txt_archivos = 'Ingrese un archivo y valor para: '+d.tipoDocumentoPersona.nombre
              }
            })
          })
        }

        if(opcionales){
          return this.documentaciones;
        }

        if(txt_archivos){
          return txt_archivos;
        }

        return this.documentaciones;
      },

      async visualizarDocumento(docPersona){
        this.$refs.refVisualizar.openmodal(docPersona);
      },

      async actualizarDocumento(docPersona, plantilla){
        window.console.log('vvvv', plantilla);
        if(!plantilla.archivo){
          this.$root.$notify.show(`Seleccione el archivo`, {color:'red',x: 'right',});
          return;
        }
        if(!plantilla.valor){
          this.$root.$notify.show(`Ingrese un valor para: `+plantilla.etiqueta, {color:'red',x: 'right',});
          return;
        }
        plantilla.loading = true;
        await actualizarDatos(docPersona,plantilla, docPersona.cargado.id);
        plantilla.loading = false;
      },
 
    },

    mounted(){ 
    }
  }
</script>